<template>
    <div class="academics-container">
        <div class="page-header">
            <h1 class="page-title">
                <span class="gradient-text">Academics</span>
                <div class="title-underline"></div>
            </h1>
        </div>
        
        <div class="container">
            <div class="academics-content">
                <div class="education-section">
                    <div class="education-card">
                        <div class="education-header">
                            <h2>Master's Degree</h2>
                            <span class="education-year">2025</span>
                        </div>
                        <div class="education-content">
                            <p class="degree">Computer Science and Engineering</p>
                            <p class="institution">
                                <a href="https://tecnico.ulisboa.pt/pt/" class="institution-link">
                                    Instituto Superior Técnico
                                </a>
                            </p>
                            <p class="location">Lisbon, Portugal</p>
                            <p class="description">
                                Specialized in Artificial Intelligence and Game Development.
                            </p>
                            <div class="achievements">
                                <div class="achievement-badge">
                                    <span class="achievement-text">Excelence Board 2023/2024</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="education-card">
                        <div class="education-header">
                            <h2>Bachelor's Degree</h2>
                            <span class="education-year">2023</span>
                        </div>
                        <div class="education-content">
                            <p class="degree">Computer Science and Engineering</p>
                            <p class="institution">
                                <a href="https://tecnico.ulisboa.pt/pt/" class="institution-link">
                                    Instituto Superior Técnico
                                </a>
                            </p>
                            <p class="location">Lisbon, Portugal</p>
                            <div class="achievements">
                                <div class="achievement-badge">
                                    <span class="achievement-text">Merit Board 2020/2021</span>
                                </div>
                                <div class="achievement-badge">
                                    <span class="achievement-text">Merit Board 2021/2022</span>
                                </div>
                                <div class="achievement-badge">
                                    <span class="achievement-text">Excelence Board 2022/2023</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="education-card">
                        <div class="education-header">
                            <h2>High School</h2>
                            <span class="education-year">2020</span>
                        </div>
                        <div class="education-content">
                            <p class="institution">Colégio Marista de Carcavelos</p>
                            <p class="location">Carcavelos, Portugal</p>
                            <p class="description">
                                Completed high school education with a focus on science and mathematics, 
                                laying the foundation for my future studies in computer science.
                            </p>
                        </div>
                    </div>

                </div>

                <div class="projects-section">
                    <h2 class="section-title">Relevant Academic Projects</h2>
                    <div class="projects-grid">
                        <div class="project-card">
                            <div class="project-header">
                                <h3>AI for Games</h3>
                                <span class="project-type">Msc Course Project</span>
                            </div>
                            <div class="project-links">
                                <a href="https://github.com/fallenatlas/Project1.IAJ_23-24" class="project-link">
                                    Project 1 - Pathfinding
                                </a>
                                <a href="https://github.com/SebastiaoCarvalho/Project2.IAJ_23-24" class="project-link">
                                    Project 2 - Decision Making
                                </a>
                                <a href="https://github.com/SebastiaoCarvalho/Project3.IAJ_23-24" class="project-link">
                                    Project 3 - Reinforcement Learning
                                </a>
                            </div>
                        </div>

                        <div class="project-card">
                            <div class="project-header">
                                <h3>Game Development Methodologies</h3>
                                <span class="project-type">Msc Course Project</span>
                            </div>
                            <div class="project-links">
                                <a href="https://sebastiaocarvalho.itch.io/cheese-in-the-trap" class="project-link">
                                    Cheese in the Trap
                                </a>
                            </div>
                        </div>

                        <div class="project-card">
                            <div class="project-header">
                                <h3>Software Verification</h3>
                                <span class="project-type">Msc Course Project</span>
                            </div>
                            <div class="project-links">
                                <a href="https://github.com/SebastiaoCarvalho/QS-P1" class="project-link">
                                    Project 1 - Dafny 
                                </a>
                                <a href="https://github.com/SebastiaoCarvalho/QS-P2" class="project-link">
                                    Project 2 - Alloy
                                </a>
                            </div>
                        </div>

                        <div class="project-card">
                            <div class="project-header">
                                <h3>Algorithms for Computer Logic</h3>
                                <span class="project-type">Msc Course Project</span>
                            </div>
                            <div class="project-links">
                                <a href="https://github.com/SebastiaoCarvalho/ALC-P1" class="project-link">
                                    Project 1 - SAT 
                                </a>
                                <a href="https://github.com/SebastiaoCarvalho/ALC-P2" class="project-link">
                                    Project 2 - SMT
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'AcademicsView',
}
</script>

<style lang="scss" scoped>
.academics-container {
    min-height: 100vh;
    padding: 2rem 0;
    animation: fadeIn 0.8s ease-out;
}

.page-header {
    text-align: center;
    margin-bottom: 3rem;
}

.page-title {
    font-size: 4rem;
    font-weight: 800;
    margin-bottom: 1rem;
    position: relative;
    display: inline-block;
    animation: fadeInDown 1s ease-out;
    
    .gradient-text {
        background: var(--primary-gradient);
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        background-clip: text;
        position: relative;
        display: inline-block;
    }
    
    .title-underline {
        width: 120px;
        height: 4px;
        background: var(--primary-gradient);
        margin: 0.5rem auto 0;
        border-radius: 2px;
        animation: scaleIn 1s ease-out 0.5s both;
    }
}

.container {
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 2rem;
}

.academics-content {
    display: flex;
    flex-direction: column;
    gap: 4rem;
}

.education-section {
    display: flex;
    flex-direction: column;
    gap: 2rem;
}

.education-card {
    background: linear-gradient(135deg, var(--background-card) 0%, #1e2328 100%);
    border-radius: 20px;
    padding: 2rem;
    box-shadow: var(--shadow-dark), var(--shadow-glow);
    border: 1px solid var(--border-color);
    transition: all 0.3s ease;
    position: relative;
    overflow: hidden;
    
    &::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        height: 4px;
        background: var(--primary-gradient);
        transform: scaleX(0);
        transition: transform 0.3s ease;
    }
    
    &:hover {
        transform: translateY(-5px);
        box-shadow: var(--shadow-hover), 0 0 30px rgba(0, 212, 255, 0.15);
        border-color: var(--border-glow);
        
        &::before {
            transform: scaleX(1);
        }
    }
    
    &.current {
        border-color: var(--primary-color);
        box-shadow: var(--shadow-dark), 0 0 20px rgba(0, 212, 255, 0.2);
        
        &::before {
            transform: scaleX(1);
        }
    }
}

.education-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 1.5rem;
    
    h2 {
        font-size: 2.2rem;
        font-weight: 700;
        color: var(--text-bright);
        margin: 0;
    }
}

.education-year {
    background: linear-gradient(135deg, var(--accent-gradient));
    color: white;
    padding: 0.5rem 1rem;
    border-radius: 20px;
    font-weight: 600;
    font-size: 0.9rem;
    
    &.current-year {
        background: var(--primary-gradient);
        animation: pulse 2s infinite;
    }
}

.education-content {
    .degree {
        font-size: 1.3rem;
        font-weight: 600;
        color: var(--primary-color);
        margin-bottom: 0.5rem;
    }
    
    .institution {
        font-size: 1.1rem;
        font-weight: 500;
        color: var(--text-bright);
        margin-bottom: 0.3rem;
    }
    
    .institution-link {
        color: var(--primary-color);
        text-decoration: none;
        transition: all 0.3s ease;
        position: relative;
        
        &::after {
            content: '';
            position: absolute;
            bottom: -2px;
            left: 0;
            width: 0;
            height: 2px;
            background: var(--primary-gradient);
            transition: width 0.3s ease;
        }
        
        &:hover {
            color: var(--text-bright);
            
            &::after {
                width: 100%;
            }
        }
    }
    
    .location {
        font-size: 1rem;
        color: var(--text-muted);
        margin-bottom: 1rem;
    }
    
    .description {
        font-size: 1rem;
        color: var(--text-light);
        line-height: 1.6;
        margin-bottom: 1rem;
    }
}

.achievements {
    display: flex;
    flex-wrap: wrap;
    gap: 1rem;
    margin-top: 1rem;
    justify-content: center;
}

.achievement-badge {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    background: rgba(0, 212, 255, 0.1);
    padding: 0.5rem 1rem;
    border-radius: 15px;
    border: 1px solid rgba(0, 212, 255, 0.3);
    
    .achievement-icon {
        font-size: 1.2rem;
    }
    
    .achievement-text {
        font-size: 0.9rem;
        font-weight: 500;
        color: var(--primary-color);
    }
}

.projects-section {
    .section-title {
        font-size: 2.5rem;
        font-weight: 700;
        color: var(--text-bright);
        margin-bottom: 2rem;
        text-align: center;
        position: relative;
        
        &::after {
            content: '';
            position: absolute;
            bottom: -10px;
            left: 50%;
            transform: translateX(-50%);
            width: 80px;
            height: 3px;
            background: var(--accent-gradient);
            border-radius: 2px;
        }
    }
}

.projects-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 2rem;
    max-width: 100%;
}

// Responsive Design - keep your existing mobile breakpoints
@media (max-width: 768px) {
    .projects-grid {
        grid-template-columns: 1fr;
    }
}

@media (max-width: 480px) {
    .projects-grid {
        grid-template-columns: 1fr;
    }
}

.project-card {
    background: linear-gradient(135deg, var(--background-card) 0%, #1e2328 100%);
    border-radius: 16px;
    padding: 1.5rem;
    box-shadow: var(--shadow-dark);
    border: 1px solid var(--border-color);
    transition: all 0.3s ease;
    
    &:hover {
        transform: translateY(-3px);
        box-shadow: var(--shadow-hover), 0 0 25px rgba(255, 107, 107, 0.1);
        border-color: rgba(255, 107, 107, 0.3);
    }
}

.project-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 1rem;
    
    h3 {
        font-size: 1.5rem;
        font-weight: 600;
        color: var(--text-bright);
        margin: 0;
    }
}

.project-type {
    background: var(--accent-gradient);
    color: white;
    padding: 0.3rem 0.8rem;
    border-radius: 12px;
    font-size: 0.8rem;
    font-weight: 500;
}

.project-links {
    display: flex;
    flex-direction: column;
    gap: 0.8rem;
}

.project-link {
    display: flex;
    align-items: center;
    gap: 0.8rem;
    color: var(--text-light);
    text-decoration: none;
    padding: 0.8rem;
    border-radius: 12px;
    background: rgba(0, 212, 255, 0.05);
    border: 1px solid rgba(0, 212, 255, 0.1);
    transition: all 0.3s ease;
    
    .link-icon {
        font-size: 1.2rem;
    }
    
    &:hover {
        background: rgba(0, 212, 255, 0.1);
        border-color: rgba(0, 212, 255, 0.3);
        color: var(--primary-color);
        transform: translateX(5px);
    }
}

// Animations
@keyframes fadeIn {
    from {
        opacity: 0;
        transform: translateY(20px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

@keyframes fadeInDown {
    from {
        opacity: 0;
        transform: translateY(-30px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

@keyframes scaleIn {
    from {
        opacity: 0;
        transform: scaleX(0);
    }
    to {
        opacity: 1;
        transform: scaleX(1);
    }
}

@keyframes pulse {
    0%, 100% {
        box-shadow: 0 0 0 0 rgba(0, 212, 255, 0.7);
    }
    50% {
        box-shadow: 0 0 0 10px rgba(0, 212, 255, 0);
    }
}

// Responsive Design
@media (max-width: 768px) {
    .page-title {
        font-size: 3rem;
    }
    
    .container {
        padding: 0 1rem;
    }
    
    .education-card {
        padding: 1.5rem;
    }
    
    .education-header {
        flex-direction: column;
        gap: 1rem;
        text-align: center;
        
        h2 {
            font-size: 1.8rem;
        }
    }
    
    .projects-grid {
        grid-template-columns: 1fr;
    }
    
    .achievements {
        justify-content: center;
    }
}

@media (max-width: 480px) {
    .page-title {
        font-size: 2.5rem;
    }
    
    .education-card {
        padding: 1rem;
    }
    
    .project-card {
        padding: 1rem;
    }
}
</style>